// -----------------------------------------------------------------------------
// Use-Cases
// -----------------------------------------------------------------------------
// import * as isotope from '../../../../node_modules/isotope-layout/dist/isotope.pkgd.min.js';
// import * as isotope from '../utility/generalUtility';

const init = () => {
  if ($('.js-use-cases').length <= 0) {
    return;
  }
  initEventListeners();
};

/**
 * Filter einrichten
 */
const initEventListeners = () => {
  filter();
};


const filter = () => {
  // init Isotope
  var $grid = $('.usecases');

  // bind filter button click
  var $filterButtonGroup = $('#filters');
  $filterButtonGroup.on('click', 'button', function () {
    var filterAttr = $( this ).attr('data-filter');
    if (filterAttr === '*') {
      $('#quicksearch').val('');
      $('#quicksearch').keyup();
    }
    location.hash = 'filter=' + encodeURIComponent( filterAttr );
  });

  // use value of search field to filter
  $('#quicksearch').keyup(debounce(function () {
    onHashchange();
  }));

  var isIsotopeInit = false;

  function onHashchange() {
    var hashFilter = getHashFilter();
    if ( !hashFilter && isIsotopeInit ) {
      return;
    }
    var filterValue = hashFilter;

    isIsotopeInit = true;

    // filter isotope
    $grid.isotope({
      itemSelector: '.usecase-element',
      layoutMode: 'fitRows',
      filter: function () {
        var $this = $(this);
        var searchResult = new RegExp($('#quicksearch').val(), 'gi') ? $this.text().match(new RegExp($('#quicksearch').val(), 'gi')) : true;
        var selectResult = filterValue ? $this.is(filterValue) : true;
        return searchResult && selectResult;
      }
    });

    // set selected class on button
    if ( hashFilter ) {
      $filterButtonGroup.find('.is-checked').removeClass('is-checked');
      $filterButtonGroup.find('[data-filter="' + hashFilter + '"]').addClass('is-checked');
    }
  }

  $(window).on( 'hashchange', onHashchange );

  // trigger event handler to init Isotope
  var urlMatch = location.hash.match(/filter=([^&]+)/i);
  console.log(location.hash.match( /filter=([^&]+)/i ));

  if (urlMatch !== null && urlMatch[1] !== null && urlMatch[1] !== '*') {
    onHashchange();
  }


  function getHashFilter() {
    var matches = location.hash.match( /filter=([^&]+)/i );
    var hashFilter = matches && matches[1];
    return hashFilter && decodeURIComponent( hashFilter );
  }

  // debounce so filtering doesn't happen every millisecond
  function debounce(fn) {
    var timeout;
    var threshold = 100;
    return function debounced() {
      clearTimeout(timeout);
      var args = arguments;
      var _this = this;

      function delayed() {
        fn.apply(_this, args);
      }

      timeout = setTimeout(delayed, threshold);
    };
  }

  var msgBox = $('.js-msg-box');
  var countBox = $('.js-count-box');
  $grid.on('arrangeComplete', function (event, filteredItems) {
    if (filteredItems.length === 0) {
      msgBox.show();
      countBox.hide();
    } else {
      msgBox.hide();
      countBox.show();
      $('.js-result-count').text(filteredItems.length);
    }
  });
};

export {
  init
};
